import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=219ce6ee&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=219ce6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ce6ee",
  null
  
)

export default component.exports